import React, { useEffect, useRef, useState } from "react";
import "../../styles/home.css";
import "../../styles/aboutus.css";
import { aboutUs } from "../../data/aboutUs";

// Same cadence as the homepage's origin-story reveal: rule, title, lede all
// pop in tight together, then each supporting paragraph lands with a wider,
// visible gap after it.
const DELAY_STEP = 0.08;
const delayStyle = (index) => ({ transitionDelay: `${index * DELAY_STEP}s` });

const PARA_START = 0.32;
const PARA_STEP = 0.22;
const paraDelayStyle = (i) => ({ transitionDelay: `${PARA_START + i * PARA_STEP}s` });

const isReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AboutUsOriginStory = () => {
  const { title, paragraphs } = aboutUs.story;

  const sectionRef = useRef(null);
  const [showContent, setShowContent] = useState(false);

  // Reveals once when the section scrolls into view. It no longer scrolls
  // the page itself: forcing the scroll here made the page jump and fight
  // the visitor's own scrolling.
  useEffect(() => {
    if (isReducedMotion()) {
      setShowContent(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setShowContent(true);
        observer.disconnect();
      },
      { threshold: 0.15 }
    );
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bv aboutus_origin_story" ref={sectionRef}>
      <div className={`bv-collapse ${showContent ? "is-open" : ""}`}>
        <div className="bv-collapse-inner">
          <div className={`bv-panel ${showContent ? "is-visible" : ""}`}>
            <div className="bv-inner">
              <div className="bv-rule bv-origin-item" style={delayStyle(0)} />

              <div className="bv-story">
                <h3
                  className={`bv-story-title aboutus-story-heading ${
                    showContent ? "is-popped" : ""
                  }`}
                  style={{ animationDelay: `${1 * DELAY_STEP}s` }}
                >
                  {title}
                </h3>

                {paragraphs.map((paragraph, i) => (
                  <p
                    className={`bv-origin-item ${
                      i === 0 ? "bv-lede" : "aboutus-story-support"
                    }`}
                    style={i === 0 ? delayStyle(2) : paraDelayStyle(i - 1)}
                    key={paragraph}
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsOriginStory;
